import { AuthenticationResult, AuthError, Configuration, PopupRequest, PublicClientApplication, SilentRequest } from "@azure/msal-browser";
import some from "lodash/some";
import { setLoginError } from "../state/actions/authActions";

import store from "../store";
import { Permission } from "../utils/enums";
import { IUser } from "../utils/types/models";

let _tenantId: string;
let _clientId: string;

let _authContext: PublicClientApplication;

export function setAdCredentials(tenantId: string, clientId: string): void {
	_tenantId = tenantId;
	_clientId = clientId;
}

export function authContext(): PublicClientApplication {
	if (_authContext) {
		return _authContext;
	}

	const tenantId: string = _tenantId;
	const clientId: string = _clientId;

	const msalConfiguration: Configuration = {
		auth: {
			clientId,
			authority: `https://login.microsoftonline.com/${tenantId}`,
			redirectUri: window.location.origin,
			postLogoutRedirectUri: window.location.origin
		},
		cache: {
			cacheLocation: "localStorage",
			storeAuthStateInCookie: false
		}
	};

	_authContext = new PublicClientApplication(msalConfiguration);

	return _authContext;
}

export async function logIn(): Promise<AuthenticationResult> {
	return authContext().loginPopup({
		scopes: [`${_clientId}/User.Read`, `${_clientId}/email`],
		prompt: "select_account"
	});
}

export async function getToken(): Promise<string> {
	const localAuthContext: PublicClientApplication = authContext();
	let response: AuthenticationResult;
	const req: SilentRequest = {
		scopes: [`${_clientId}/User.Read`, `${_clientId}/email`],
		account: localAuthContext.getAllAccounts()[0]
	};
	try {
		response = await localAuthContext.acquireTokenSilent(req);
	} catch (error) {
		if (error instanceof AuthError || error.errorCode === "consent_required" || error.errorCode === "interaction_required" || error.errorCode === "login_required") {
			const popupRequest: PopupRequest = {
				scopes: req.scopes
			};

			try {
				response = await localAuthContext.acquireTokenPopup(popupRequest);
			} catch (error2) {
				store.dispatch(setLoginError(error2.errorCode, error2.errorMessage));
			}
		}
	}
	if (response) {
		return response.accessToken;
	}
	return null;
}

export function hasPermission(...permissions: Permission[]): boolean {
	const currentUser: IUser = store.getState().authenticationState.currentUser;

	if (!permissions || permissions.length <= 0) {
		return true;
	}

	if (currentUser) {
		return some(permissions, (permission: string) => {
			return currentUser.permissions[permission];
		});
	}

	return false;
}
